import Vue from 'vue';
import Calc from './components/calculator/inflation.vue';
var rawData = document.getElementById('inflation_data').value, data = JSON.parse(rawData);
new Vue({
    el: '#entry-point',
    render: function (h) {
        return h(Calc, {
            props: {
                inflData: data
            }
        });
    }
});
